/**
 * Coup de pouce — Attendu 1046 « Savoir que pour compléter une addition à
 * trou, on utilise une soustraction ».
 *
 * UNE SEULE aide, partagée par les cinq generator_keys : les cinq formats
 * travaillent la même règle sur des supports différents (revue prof
 * 2026-09-07). Le schéma en barres du cycle 3 porte l'explication, le texte
 * se limite à deux lignes.
 *
 * EXEMPLE SACRIFIÉ : 14 + … = 32. Il ne peut sortir d'aucune carte :
 *   - Série flash et Drag (régime « je calcule ») : 14 est hors des petits
 *     nombres (g ≤ 9), 14 + 18 demande une retenue (exclu de l'écart), 32
 *     n'est pas rond ;
 *   - QCM, Vrai/Faux, Problème (régime « je choisis ») : arrivée entière
 *     ≥ 100 par construction.
 *   Invariant protégé par src/generators/tests/cdp1046.self.test.js.
 *
 * Proportions : la barre est à l'échelle (10 px par unité) : le morceau « ? »
 * (18) est un peu plus long que le morceau 14, comme l'élève l'a appris en
 * CM1. La couleur du « ? » est reprise sur le 18 du calcul : c'est le seul
 * lien visuel entre la figure et le calcul.
 */

const ORANGE = '#EA580C';
const ORANGE_CLAIR = '#FED7AA';
const BLEU_CLAIR = '#DBEAFE';
const GRIS = '#E2E8F0';
const ENCRE = '#1E293B';

/**
 * Le texte vit DANS la figure (revue prof 2026-09-07) : la fiche d'aide
 * affiche toujours les lignes avant la figure, or ici c'est le schéma qui
 * explique et le texte qui conclut. Les deux phrases sont reprises dans
 * l'aria-label, que la fiche lit pour la synthèse vocale.
 */
const SVG_BARRES = `
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 400 312" role="img"
     aria-label="Schéma en barres : une barre entière de 32, et dessous la même longueur coupée en un morceau 14 et un morceau inconnu. Le calcul 32 moins 14 égale 18 donne le morceau inconnu. Dans une addition à trou, le trou c'est ce qui manque pour arriver au total : le total moins le nombre déjà donné. Je vérifie en refaisant l'addition : 14 plus 18 égale 32.">
  <text x="200" y="30" font-size="22" font-weight="bold" text-anchor="middle" fill="${ENCRE}">14 + … = 32</text>
  <rect x="40" y="52" width="320" height="36" fill="${GRIS}" stroke="${ENCRE}" stroke-width="1.5"/>
  <text x="200" y="77" font-size="20" font-weight="bold" text-anchor="middle" fill="${ENCRE}">32</text>
  <rect x="40" y="100" width="140" height="36" fill="${BLEU_CLAIR}" stroke="${ENCRE}" stroke-width="1.5"/>
  <text x="110" y="125" font-size="20" font-weight="bold" text-anchor="middle" fill="${ENCRE}">14</text>
  <rect x="180" y="100" width="180" height="36" fill="${ORANGE_CLAIR}" stroke="${ORANGE}" stroke-width="2"/>
  <text x="270" y="126" font-size="22" font-weight="bold" text-anchor="middle" fill="${ORANGE}">?</text>
  <text x="200" y="180" font-size="24" font-weight="bold" text-anchor="middle" fill="${ENCRE}">32 − 14 = <tspan fill="${ORANGE}">18</tspan></text>
  <text x="200" y="220" font-size="15" text-anchor="middle" fill="${ENCRE}">Dans une addition à trou, le trou c'est ce qui manque</text>
  <text x="200" y="241" font-size="15" text-anchor="middle" fill="${ENCRE}">pour arriver au total :</text>
  <text x="200" y="263" font-size="15" font-weight="bold" text-anchor="middle" fill="${ENCRE}">le total moins le nombre déjà donné.</text>
  <text x="200" y="296" font-size="15" text-anchor="middle" fill="${ENCRE}">Je vérifie en refaisant l'addition : 14 + 18 = 32.</text>
</svg>`.trim();

const AIDE = {
    pages: [
        { titre: 'Ce qui manque', svg: SVG_BARRES },
    ],
};

const CP_1046 = {
    flash_texte_trou_saisie: AIDE,
    calcul_qcm_unique: AIDE,
    lettres_texte_trou_drag: AIDE,
    vf_tableau_vf: AIDE,
    citerne_qcm_unique: AIDE,
};

export default CP_1046;
